import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This is will "),
  /*#__PURE__*/_createElementVNode("strong", null, "permanently delete"),
  /*#__PURE__*/_createTextVNode(" this account")
], -1)
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "flex flex-wrap mt-6 space-x-0 md:space-x-3" }
const _hoisted_5 = { class: "w-full md:w-1/4" }
const _hoisted_6 = {
  for: "firstname",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_7 = { class: "w-full mt-6 md:w-1/4 md:mt-0" }
const _hoisted_8 = {
  for: "lastname",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_9 = { class: "flex flex-wrap mt-6 mb-4 space-y-4 md:space-x-3 md:space-y-0" }
const _hoisted_10 = { class: "w-full md:w-1/4" }
const _hoisted_11 = {
  for: "email-address",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_12 = {
  for: "email-address",
  class: "block mt-1 text-sm italic text-gray-900"
}
const _hoisted_13 = { class: "w-full md:w-1/4" }
const _hoisted_14 = {
  for: "mobile-number",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_15 = { class: "flex flex-wrap mt-6 mb-4 space-x-3" }
const _hoisted_16 = { class: "w-full md:w-1/4" }
const _hoisted_17 = {
  for: "email-address",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_18 = { class: "w-full md:w-1/4" }
const _hoisted_19 = {
  for: "mobile-number",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_20 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_21 = {
  for: "job_roles",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_22 = {
  for: "job_roles",
  class: "block mb-2 text-sm italic text-gray-900"
}
const _hoisted_23 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_24 = {
  for: "bio",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_26 = { class: "mt-6" }
const _hoisted_27 = { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }
const _hoisted_28 = { class: "mt-2 text-xl" }
const _hoisted_29 = { class: "w-full mt-4 md:w-1/2" }
const _hoisted_30 = {
  for: "public",
  class: "block my-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_31 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_32 = ["checked", "value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "mt-4 text-xl" }
const _hoisted_38 = { class: "w-full mt-4 md:w-1/2" }
const _hoisted_39 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_40 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_41 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_42 = {
  for: "programme_setting",
  class: "block mb-2 text-sm italic text-gray-900"
}
const _hoisted_43 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_44 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_45 = { class: "space-y-2" }
const _hoisted_46 = { class: "space-x-2" }
const _hoisted_47 = ["value", "checked"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_53 = {
  for: "other_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_54 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_55 = {
  for: "other_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_57 = { class: "mt-6" }
const _hoisted_58 = { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }
const _hoisted_59 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_60 = {
  for: "public",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_61 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_62 = ["checked", "value"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = ["href"]
const _hoisted_67 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_68 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_69 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_70 = {
  for: "programme_setting",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_71 = {
  for: "programme_setting",
  class: "block mb-2 text-sm italic text-gray-900"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_73 = { class: "w-full mt-6 md:w-1/2" }
const _hoisted_74 = { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", {
  for: "email-address",
  class: "block my-2 text-sm font-medium text-gray-900"
}, "Organisation", -1)
const _hoisted_76 = { class: "mt-6" }
const _hoisted_77 = { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }
const _hoisted_78 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_79 = { class: "w-full md:w-1/4" }
const _hoisted_80 = {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_81 = { class: "w-full md:w-1/4" }
const _hoisted_82 = {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_83 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_84 = { class: "w-full md:w-1/4" }
const _hoisted_85 = {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Please select", -1)
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_89 = { class: "w-full md:w-1/4" }
const _hoisted_90 = {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_92 = ["value"]
const _hoisted_93 = { class: "w-full md:w-1/4" }
const _hoisted_94 = {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Please select", -1)
const _hoisted_96 = ["value"]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_98 = { class: "flex my-4 space-x-6" }

import { ref } from "vue";
import { storeToRefs } from "pinia";

import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import RouterButton from "@/components/RouterButton.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RoleGuard from "@/components/RoleGuard.vue";

import { useGlobalStore } from "@/store";
import { useUserStore } from "@/store";
import router from "@/router";
import api from "@/api/api";
import { Country } from "@/types";
import { slugify } from "@/utils/slugify";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProfile',
  async setup(__props) {

let __temp: any, __restore: any

const globalStore = useGlobalStore();
const userStore = useUserStore();
const { languages, timezones } = storeToRefs(globalStore);
const { user, facilitatorRoles, trainerRoles } = storeToRefs(userStore);
const website_url = process.env.VUE_APP_WEBSITE_URL;

if (user.value.job_role === null) {
  user.value.job_role = {
    data: [],
  };
}

if (user.value.programme_setting === null) {
  user.value.programme_setting = {
    data: [],
    other: {
      field_1: "",
      field_2: "",
    },
  };
}

const isSaving = ref(false);
const isConfirmationModalOpen = ref(false);

const job_roles = ref("");
const countries = ref([] as Country[]);

const worksWithOptions = [
  "Early Years setting (children under 4 years)",
  "School (children 4-11 years)",
  "Secondary School (children 11-16 years)",
  "Further Education (16+ years)",
  "Adult service (18+ years)",
  "Older adult service (65+ years)",
  "Specialist Educational provision",
  "State funded healthcare setting (e.g NHS)",
  "Private healthcare setting (e.g private therapy centre)",
  "other-1",
  "other-2",
];

async function saveUser() {
  isSaving.value = true;

  try {
    const formattedJobRoles = job_roles.value.split(`\n`);

    const response = await api.auth.updateProfile({
      email: user.value.email,
      firstName: user.value.first_name,
      lastName: user.value.last_name,
      bio: user.value.bio,
      mobileNumber: user.value.mobile_number,
      public: user.value.public,
      language: user.value.language ?? "en",
      city: user.value.city,
      county: user.value.county,
      state: user.value.state,
      country: user.value.country,
      programme_setting: user.value.programme_setting,
      timezone: user.value.timezone,
      job_role: formattedJobRoles,
      directory_email_address: user.value.directory_email_address,
      directory_website: user.value.directory_website,
      sub_organisation: user.value.sub_organisation,
    });

    if (response.meta.status !== 200) {
      throw Error();
    }

    document.cookie = `pi-lang=${response.data.user.language};domain=.playincluded.com;path=/;expires=Fri, 31 Dec 9989 23:59:59 GMT;SameSite=None;Secure=;`;

    await userStore.fetchUser();
    globalStore.toast("SUCCESS", "Profile updated successfully");

    if (response.data.logout) {
      return router.push("/logout");
    }

    window.location.reload();
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error saving profile changes");
  } finally {
    isSaving.value = false;
  }
}

function isOptionSelected(option: string) {
  if (user.value.programme_setting === null) {
    return false;
  }

  if (user.value.programme_setting.data.find(i => i === option)) {
    return true;
  }

  return false;
}

/** Facilitators / Trainers opt in/out of public listing */
async function updatePublicProfile() {
  user.value.public = !user.value.public;
}

countries.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listCountries())),
  __temp = await __temp,
  __restore(),
  __temp
)).countries;
job_roles.value = user.value.job_role.data.join("\n");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ConfirmationModal, {
      isOpen: isConfirmationModalOpen.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isConfirmationModalOpen.value = false)),
      onDelete: _ctx.deleteUser,
      buttonText: "Confirm Deletion"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["isOpen", "onDelete"]),
    _createVNode(TitleHeader, {
      title: _ctx.$t('my-profile')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("first-name")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "firstname",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).first_name) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
            placeholder: "firstname",
            required: ""
          }, null, 512), [
            [_vModelText, _unref(user).first_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("last-name")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "lastname",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user).last_name) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
            placeholder: "lastname",
            required: ""
          }, null, 512), [
            [_vModelText, _unref(user).last_name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("email-address")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "email-address",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(user).email) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "email",
            required: ""
          }, null, 512), [
            [_vModelText, _unref(user).email]
          ]),
          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("email-address-label")) + ". " + _toDisplayString(_ctx.$t("email-helptext")), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("mobile-number")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "mobile-number",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(user).mobile_number) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "mobile no."
          }, null, 512), [
            [_vModelText, _unref(user).mobile_number]
          ])
        ])
      ]),
      _createVNode(RoleGuard, { roles: ['parent', 'brick-club-family'] }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("secondary-email")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "email-address",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(user).secondary_email) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                placeholder: "email",
                required: ""
              }, null, 512), [
                [_vModelText, _unref(user).secondary_email]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("secondary-phone")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "mobile-number",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(user).secondary_phone) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                placeholder: "mobile no."
              }, null, 512), [
                [_vModelText, _unref(user).secondary_phone]
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("your-roles")), 1),
        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("your-roles-label")), 1),
        _withDirectives(_createElementVNode("textarea", {
          type: "text",
          id: "job_roles",
          class: "block w-full h-24 py-2 text-gray-900 border border-gray-600 rounded",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((job_roles).value = $event))
        }, null, 512), [
          [_vModelText, job_roles.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("bio")), 1),
        _withDirectives(_createElementVNode("textarea", {
          type: "text",
          id: "bio",
          class: "block w-full h-48 py-2 text-gray-900 border border-gray-600 rounded",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(user).bio) = $event))
        }, null, 512), [
          [_vModelText, _unref(user).bio]
        ])
      ]),
      _hoisted_25
    ]),
    _createVNode(RoleGuard, {
      roles: [..._unref(facilitatorRoles), 'facilitator-organisation', 'admin']
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.$t("facilitator-settings")), 1),
          _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.$t("register-of-practitioners")), 1),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("show-facilitator-profile")), 1),
            _createElementVNode("label", _hoisted_31, [
              _createElementVNode("input", {
                id: "public",
                type: "checkbox",
                checked: _unref(user).public,
                value: _unref(user).public,
                class: "sr-only peer",
                onChange: updatePublicProfile
              }, null, 40, _hoisted_32),
              _hoisted_33
            ]),
            (!_unref(user).public)
              ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.$t("facilitator-public-message")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.$t("your-profile-is-currently-visible-facilitator")), 1)),
            _createElementVNode("p", {
              innerHTML: _ctx.$t('facilitator-public-helptext'),
              class: "hyperlinked-paragraph"
            }, null, 8, _hoisted_36)
          ]),
          _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.$t("directory-settings")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("directory-settings-helptext")), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("directory-email-address")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(user).directory_email_address) = $event)),
              class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
            }, null, 512), [
              [_vModelText, _unref(user).directory_email_address]
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("directory-website")), 1),
            _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("directory-website-helptext-2")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(user).directory_website) = $event)),
              class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
            }, null, 512), [
              [_vModelText, _unref(user).directory_website]
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("works-with")), 1),
            _createElementVNode("div", _hoisted_45, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(worksWithOptions, (option, index) => {
                return _createElementVNode("div", { key: index }, [
                  _createElementVNode("label", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "p-2",
                      value: option,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(user).programme_setting.data) = $event)),
                      checked: isOptionSelected(option)
                    }, null, 8, _hoisted_47), [
                      [_vModelCheckbox, _unref(user).programme_setting.data]
                    ]),
                    (!['other-1', 'other-2'].includes(option))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(option), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_49, [
                          (option === 'other-1')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Community setting (please specifiy)"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_51, "A different setting not already covered (please specify)"))
                        ]))
                  ])
                ])
              }), 64)),
              _createElementVNode("div", null, [
                (_unref(user).programme_setting.other.field_1 && isOptionSelected('other-1'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("community-setting")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "other_setting",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(user).programme_setting.other.field_1) = $event)),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        placeholder: "Other setting"
                      }, null, 512), [
                        [_vModelText, _unref(user).programme_setting.other.field_1]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(user).programme_setting.other.field_2 && isOptionSelected('other-2'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("other-setting")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "other_setting",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(user).programme_setting.other.field_2) = $event)),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        placeholder: "Other setting"
                      }, null, 512), [
                        [_vModelText, _unref(user).programme_setting.other.field_2]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _hoisted_56
      ]),
      _: 1
    }, 8, ["roles"]),
    _createVNode(RoleGuard, { roles: _unref(trainerRoles) }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("h2", _hoisted_58, _toDisplayString(_ctx.$t("trainer-settings")), 1),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t("show-trainer-profile")), 1),
            _createElementVNode("label", _hoisted_61, [
              _createElementVNode("input", {
                id: "public",
                type: "checkbox",
                checked: _unref(user).public,
                value: _unref(user).public,
                class: "sr-only peer",
                onChange: updatePublicProfile
              }, null, 40, _hoisted_62),
              _hoisted_63
            ]),
            (!_unref(user).public)
              ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(_ctx.$t("trainer-public-message")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(_ctx.$t("your-profile-is-currently-visible-trainer")), 1)),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("trainer-register-of-practitioners-message")) + " ", 1),
              _createElementVNode("a", {
                href: `${_unref(website_url)}/courses/register-of-practitioners/`,
                class: "text-blue-500 underline",
                target: "_blank"
              }, _toDisplayString(_ctx.$t("register-of-practitioners")), 9, _hoisted_66),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("trainer-register-of-practitioners-message-2")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t("directory-email-address")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(user).directory_email_address) = $event)),
              class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
            }, null, 512), [
              [_vModelText, _unref(user).directory_email_address]
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t("directory-website")), 1),
            _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("directory-website-helptext-2")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(user).directory_website) = $event)),
              class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
            }, null, 512), [
              [_vModelText, _unref(user).directory_website]
            ])
          ]),
          _hoisted_72
        ])
      ]),
      _: 1
    }, 8, ["roles"]),
    _createElementVNode("div", _hoisted_73, [
      _createElementVNode("h2", _hoisted_74, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("organisation")), 1)
      ]),
      _hoisted_75,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "sub-organisation",
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(user).sub_organisation) = $event)),
        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
        placeholder: "organisation"
      }, null, 512), [
        [_vModelText, _unref(user).sub_organisation]
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _createElementVNode("h2", _hoisted_77, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("language-and-region")), 1)
      ]),
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("city")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "city",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(user).city) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
            placeholder: "city"
          }, null, 512), [
            [_vModelText, _unref(user).city]
          ])
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("label", _hoisted_82, _toDisplayString(_unref(user).state ? _ctx.$t("state") : _ctx.$t("county")), 1),
          (_unref(user).state)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "text",
                id: "mobile",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(user).state) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                placeholder: "New York",
                required: ""
              }, null, 512)), [
                [_vModelText, _unref(user).state]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                id: "mobile",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(user).county) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                placeholder: "Central London",
                required: ""
              }, null, 512)), [
                [_vModelText, _unref(user).county]
              ])
        ])
      ]),
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t("country")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "subscription",
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(user).country) = $event)),
            class: "text-black border rounded w-full font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600 capitalize"
          }, [
            _hoisted_86,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (region) => {
              return (_openBlock(), _createElementBlock("option", {
                value: region.name,
                key: region.id,
                class: "capitalize"
              }, _toDisplayString(region.name), 9, _hoisted_87))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(user).country]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.$t("language")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "subscription",
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(user).language) = $event)),
            class: "text-black border rounded w-full capitalize font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _hoisted_91,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
              return (_openBlock(), _createElementBlock("option", {
                value: language.locale,
                key: language.id,
                class: "capitalize"
              }, _toDisplayString(_ctx.$t(_unref(slugify)(language.name))), 9, _hoisted_92))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(user).language]
          ])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t("timezone")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "subscription",
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(user).timezone) = $event)),
            class: "text-black border rounded w-full capitalize font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _hoisted_95,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timezones), (timezone) => {
              return (_openBlock(), _createElementBlock("option", {
                value: timezone,
                key: timezone.id,
                class: "capitalize"
              }, _toDisplayString(timezone), 9, _hoisted_96))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(user).timezone]
          ])
        ])
      ]),
      _hoisted_97
    ]),
    _createElementVNode("div", _hoisted_98, [
      _createVNode(DefaultButton, {
        onAction: saveUser,
        type: "primary",
        loading: isSaving.value,
        disabled: false
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("save-changes")), 1)
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(RouterButton, {
        to: { name: 'Dashboard' },
        type: "secondary",
        class: "capitalize"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})